module.exports = __webpack_public_path__ + "assets/img/soft11.dd585315.jpg";